import type { NavBarAuthSourceConfig } from './useNavBarAuthHandlers.types';

import queryString from 'utils/query-string';

export const formatNavBarAuthRoute = ({
  source,
  query = {}
}: Pick<NavBarAuthSourceConfig, 'source' | 'query'>) =>
  `/${source.toLowerCase()}?${queryString.stringify(query)}`;
